<template>
  <v-container fluid class="futuristic-panel">
    <v-card flat class="futuristic-card">
      <v-card-title class="panel-heading">
        <h4 class="earth-color">EXCHANGE HISTORY</h4>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          label="Search"
          single-line
          hide-details
          v-model="search"
          class="futuristic-input"
          outlined
        ></v-text-field>
      </v-card-title>
      <hr class="futuristic-divider" />
      <v-data-table
        :headers="columns"
        :items="allExchanges"
        :search="search"
        :rows-per-page-items="[10,25,{'text':'All','value':-1}]"
        :disable-initial-sort="true"
        :loading="$loadingTrue"
        class="futuristic-table"
      >
        <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td class="futuristic-table-cell">{{ formated_date_time(props.item.created_at) }}</td>
          <td class="futuristic-table-cell">{{ props.item.currency }}</td>
          <td class="futuristic-table-cell">{{ props.item.buy_amount }}</td>
          <td class="futuristic-table-cell">{{ props.item.sell_amount }}</td>
          <td class="futuristic-table-cell">{{ props.item.user }}</td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning" class="futuristic-alert">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import CurrencyHistory from '../../../mixins/Computed/Finance/CurrencyVuex'
import DateMixins from '../../../mixins/Functions/DateMixins'
export default {
  data () {
    return {
      search: '',
      columns: [
        {
          text: 'Date',
          value: 'created_at'
        },
        {
          text: 'Currency',
          value: 'currency'
        },
        {
          text: 'Buying value',
          value: 'buy_amount'
        },
        {
          text: 'Selling value',
          value: 'sell_amount'
        },
        {
          text: 'Updated By',
          value: 'user'
        }
      ]
    }
  },
  created () {
    this.$store.dispatch('get_all_exchanges')
  },
  mixins: [CurrencyHistory, DateMixins]
}
</script>

<style scoped>
/* Futuristic Panel */
.futuristic-panel {
  background: #f5f7fa;
  padding: 16px;
  border-radius: 8px;
}

/* Futuristic Card */
.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  margin-bottom: 16px;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.panel-heading {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px 8px 0 0;
}

.earth-color {
  color: #4caf50;
  font-weight: 600;
  margin: 0;
}

.futuristic-divider {
  border: 0;
  height: 1px;
  background: linear-gradient(to right, rgba(76, 175, 80, 0.2), rgba(76, 175, 80, 0.8), rgba(76, 175, 80, 0.2));
  margin: 8px 0 16px;
}

/* Search Input */
.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
  margin-bottom: 16px;
}

.futuristic-input >>> .v-text-field__slot input {
  color: #333;
}

/* Data Table */
.futuristic-table {
  background: #f5f7fa;
  border-radius: 8px;
}

.futuristic-table >>> .v-datatable__thead th {
  color: #4caf50;
  font-weight: 600;
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
}

.futuristic-table-cell {
  color: #333;
  padding: 12px;
}

/* Alert Styling */
.futuristic-alert {
  border-radius: 8px;
  background: #ffebee;
  color: #c62828;
}

/* Responsive Adjustments */
@media (max-width: 960px) {
  .futuristic-panel {
    padding: 12px;
  }

  .panel-heading {
    padding: 12px;
  }

  .futuristic-table-cell {
    padding: 8px;
  }
}

@media (max-width: 600px) {
  .futuristic-card {
    border-radius: 6px;
  }

  .panel-heading {
    border-radius: 6px 6px 0 0;
  }

  .futuristic-input >>> .v-input__slot {
    border-radius: 6px;
  }

  .futuristic-table >>> .v-datatable__thead th {
    font-size: 0.9rem;
  }

  .futuristic-table-cell {
    font-size: 0.85rem;
    padding: 6px;
  }
}
</style>